const ThemeIcon = () => {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.24995 13.875C8.24995 12.6141 8.62384 11.3816 9.32434 10.3332C10.0248 9.28488 11.0205 8.46778 12.1853 7.98527C13.3502 7.50276 14.632 7.37652 15.8687 7.6225C17.1053 7.86848 18.2412 8.47564 19.1328 9.3672C20.0243 10.2588 20.6315 11.3947 20.8775 12.6313C21.1234 13.8679 20.9972 15.1497 20.5147 16.3146C20.0322 17.4795 19.2151 18.4751 18.1667 19.1756C17.1184 19.8761 15.8858 20.25 14.625 20.25H7.12495C6.52602 20.2495 5.93438 20.1186 5.39116 19.8663C4.84793 19.6141 4.36615 19.2466 3.9793 18.7893C3.59245 18.3321 3.30981 17.7961 3.15103 17.2186C2.99224 16.6411 2.96112 16.036 3.05982 15.4452C3.15852 14.8545 3.38468 14.2923 3.72258 13.7978C4.06048 13.3033 4.50201 12.8883 5.01649 12.5816C5.53097 12.275 6.10606 12.0841 6.70178 12.0221C7.2975 11.9602 7.89956 12.0287 8.46613 12.2229'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.46835 5.31836L7.07764 3.10254'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.56428 7.16799L2.72119 5.87744'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M3.81836 10.5293L1.60254 10.92'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M10.8301 6.06428L12.1206 4.22119'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.84139 12.6892C4.41918 12.1998 4.10734 11.6251 3.92708 11.0044C3.74683 10.3837 3.70239 9.73141 3.79679 9.09197C3.89119 8.45253 4.12222 7.84092 4.47415 7.29876C4.82608 6.7566 5.29065 6.2966 5.83628 5.95006C6.3819 5.60352 6.99576 5.37856 7.6361 5.2905C8.27645 5.20244 8.92825 5.25334 9.54716 5.43973C10.1661 5.62612 10.7376 5.94364 11.2228 6.37067C11.708 6.79771 12.0955 7.32425 12.3591 7.91447'
        stroke='currentColor'
        strokeWidth='1.5'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default ThemeIcon;
